import React from 'react'

const JobUnits = props => {
  const {
    jobItem: { allowed_locus_groups, allowed_locuses },
  } = props
  const jobUnits = [...allowed_locus_groups, ...allowed_locuses]

  return jobUnits.reduce((resultArr, unit) => {
    const unitElement = <span key={unit.id}>{unit.name}</span>

    resultArr.push(unitElement)

    return resultArr
  }, [])
}

export default JobUnits
